export default __webpack_public_path__ + "static/equilibre_double_iphones-ce52a0382b8e1e129aa8d4ef15e3fffd.png";